import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/EInvoice";

export const Create = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Create`, options);

export const Get = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Get/:invoiceId`, options);

export const GetAll = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetAll`, options);

export const GetBySaleId = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetBySaleId/:saleId`, options);

export const RefreshStatus = (options) =>
  GENERATE_URL(`${PREFIX_URL}/RefreshStatus/:invoiceId`, options);

export const GetXml = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetXml/:invoiceId`, options);

export const GetPdf = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetPdf/:invoiceId`, options);

export const CancelEArchive = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CancelEArchive/:invoiceId`, options);

export const Retry = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Retry/:invoiceId`, options);

export default {
  Create,
  Get,
  GetAll,
  GetBySaleId,
  RefreshStatus,
  GetXml,
  GetPdf,
  CancelEArchive,
  Retry,
};
